<template>
  <div>
    <v-toolbar color="secondary" :style="navbarStyle">
      <v-icon
        class="sidebar-icon"
        color="primary"
        @click.stop="openSidebar = !openSidebar"
        left
      >
        fa-bars
      </v-icon>

      <v-spacer />

      <a :href="logoLink">
        <img
          v-if="!$vuetify.theme.dark"
          width="140"
          src="../../images/logo-light.png"
          alt="Logo"
          :href="logoLink"
        />
        <img
          v-if="$vuetify.theme.dark"
          width="140"
          src="../../images/logo-dark.png"
          alt="Logo"
          :href="logoLink"
        />
      </a>

      <v-spacer />

      <v-row class="user-tools">
        <v-icon
          class="sidebar-icon"
          color="primary"
          @click.stop="openUserMenu = !openUserMenu"
          left
          >fa-user</v-icon
        >
      </v-row>
    </v-toolbar>

    <v-navigation-drawer
      style="padding: 0 10px !important; width: fit-content !important"
      color="secondary"
      v-model="openSidebar"
      app
      overflow
      temporary
    >
      <SidebarItem
        v-for="(item, i) in sidebarItems"
        :key="i"
        :item="item"
        :level="0"
      />
    </v-navigation-drawer>

    <v-navigation-drawer
      style="padding: 0 !important; width: fit-content !important"
      v-model="openUserMenu"
      color="secondary"
      app
      clipped
      right
      temporary
    >
      <v-col class="user-menu">
        <v-col style="flex-grow: 0 !important">
          <v-subheader style="color: #64c832">Olá {{ userName }}!</v-subheader>

          <UserMenuItem
            v-for="item in userMenuItems"
            :key="item.text"
            :item="item"
            :level="0"
          />

          <v-list-item v-if="showChangePassword && !semAlterarSenha" :style="itemStyle" @click="() => changePassDialog = !changePassDialog">
            <div style="width: 32px; display: flex; justify-content: center">
              <v-icon class="sidebar-icon">fa-lock</v-icon>
            </div>

            <v-list-item-content>
              <v-list-item-title class="sidebar-text" style="margin-right: 20px"
                >Alterar Senha</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item :style="itemStyle" @click="logoff">
            <div style="width: 32px; display: flex; justify-content: center">
              <v-icon class="sidebar-icon">fa-arrow-right-from-bracket</v-icon>
            </div>

            <v-list-item-content>
              <v-list-item-title class="sidebar-text" style="margin-right: 20px"
                >Sair</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item style="padding: 0 !important">
            <p-theme-switch />
          </v-list-item>
        </v-col>

        <v-col style="flex-grow: 0 !important">
          <div>
            <p :style="versionStyle">Versão: {{ version }}</p>
            <p :style="versionStyle">Data: {{ versionDate }}</p>
          </div>
        </v-col>
      </v-col>
    </v-navigation-drawer>
    <PChangePasswordModal v-model="changePassDialog" />
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem.vue";
import UserMenuItem from "./UserMenuItem.vue";
import PThemeSwitch from "../PThemeSwitch/PThemeSwitch.vue";
import PChangePasswordModal from "../PChangePasswordModal/PChangePasswordModal.vue";
import logoffService from "../../api/logoff";
import csrfTokenService from "../../api/csrfToken";

import { store } from "../../api/store";

export default {
  name: "p-navigation",

  components: { SidebarItem, UserMenuItem, PThemeSwitch, PChangePasswordModal },

  data: () => ({
    openSidebar: false,
    openUserMenu: false,

    version: process.env.VUE_APP_VERSION,
    versionDate: process.env.VUE_APP_DATE,
    logoLink: `/${process.env.VUE_APP_PUBLIC_PATH || ""}`,

    changePassDialog: false,
    showChangePassword: store.getters.user.auth_local
  }),

  props: [
    "sidebarItems",
    "userName",
    "userMenuItems",
    "withNotifications",
    "notifications",
    "semAlterarSenha"
  ],

  computed: {
    navbarStyle() {
      return {
        "border-bottom": "1px solid #64c832 !important",
        "box-shadow": `0 0 10px ${
          this.$vuetify.theme.dark ? "#ffffff55" : "#00000033"
        } !important`,
      };
    },

    versionStyle() {
      return {
        color: `${this.$vuetify.theme.dark ? "#bbb" : "#666"}`,
        "margin-bottom": "2px !important",
      };
    },

    itemStyle() {
      return {
        "margin-left": "0px",
        display: "flex",
        "justify-content": "space-between",
        padding: "5px 0 !important",
        "border-bottom": "solid 1px #64c832",
        cursor: "pointer",
      };
    },
  },

  methods: {
    logoff() {
      this.loading = !this.loading;
      csrfTokenService.API.Objects.get_token()
        .then((resp1) => {
          if(resp1.status === 200){
            logoffService.API.Actions.logoff(resp1.data.csrf_token)
            .then((resp2) => {
              if (resp2.data.status === true) {
                store.dispatch("logoff");
              }
            })
            .catch((err) => {
              this.message = err.response.data.message ? err.response.data.message : "Falha ao realizar Logout!";
            });
          }          
        }).catch((err) => {
          this.message = err.response.data.error ? err.response.data.error : "Falha ao realizar Logout [csrf_token inválido]!";
        });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
@import "./styles.css";

.sidebar-icon {
  color: var(--v-primary-base) !important;

  margin: 0 10px 0 0;

  font-size: 1.2em !important;
}

.sidebar-text {
  color: var(--v-primary-base);
}
</style>
